export default __webpack_public_path__ + "static/media/kitchen-interior@2x.2e32de22.png";